import { RowCrudStatus } from "../../common/types";
import {
  LlmProvider,
  LlmProviderCreateMutationVariables,
  LlmProviderUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";

export type LlmProviderValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  code: string;
  requiresApiKey: boolean;
  requiresBaseUrl: boolean;
  defaultModels: string[];
  logoUrl: string;
};

export type LlmProviderErrorsType = {
  name?: { message: string; fieldLabel: string };
  code?: { message: string; fieldLabel: string };
  requiresApiKey?: { message: string; fieldLabel: string };
  requiresBaseUrl?: { message: string; fieldLabel: string };
  defaultModels?: { message: string; fieldLabel: string };
  logoUrl?: { message: string; fieldLabel: string };
};

export function LlmProviderValuesInit(): LlmProviderValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    code: "",
    requiresApiKey: false,
    requiresBaseUrl: false,
    defaultModels: [],
    logoUrl: "",
  };
}

export type LlmProviderType = LlmProvider | LlmProviderValuesType;

export function llmProviderDisplayId(
  source: Partial<LlmProvider>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getLlmProviderValues(
  source: LlmProviderType,
  _langStore: LangStore,
  _duplicated: boolean = false
): LlmProviderValuesType {
  const entityValues = LlmProviderValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : llmProviderDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.code = source.code;
  entityValues.requiresApiKey = source.requiresApiKey || false;
  entityValues.requiresBaseUrl = source.requiresBaseUrl || false;
  entityValues.defaultModels = source.defaultModels;
  entityValues.logoUrl = source.logoUrl || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getLlmProviderUpdateVariables(
  values: LlmProviderValuesType
): LlmProviderUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    code: values.code,
    requiresApiKey: values.requiresApiKey,
    requiresBaseUrl: values.requiresBaseUrl,
    defaultModels: values.defaultModels,
    logoUrl: blankToNull(values.logoUrl),
  };
}

export function getLlmProviderCreateVariables(
  values: LlmProviderValuesType
): LlmProviderCreateMutationVariables {
  return {
    name: values.name,
    code: values.code,
    requiresApiKey: values.requiresApiKey,
    requiresBaseUrl: values.requiresBaseUrl,
    defaultModels: values.defaultModels,
    logoUrl: blankToNull(values.logoUrl),
  };
}
